import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import './App.css';
import Main from './Main';
import Summit from './Summit';
import ScrollToTop from "./scrolltotop"; // Import it
// import ComingSoon from './coming_soon';
import Startup from './startupexpo';
import Newecell from './newecell';
import RecruitmentPage from './RecruitmentPage';
// import Registration from './e_summit_components/Registration/Registration';
import FormLinks from './e_summit_components/Registration/FormLinks';
import IshaanSharma from './e_summit_components/Registration/IshaanSharma';
import ProductDesign from './e_summit_components/Registration/ProductDesign';
import InternshipFair from './e_summit_components/Registration/InternshipFair';
import IPLAuction from './e_summit_components/Registration/IPLAuction';
import SilentDisco from './e_summit_components/Registration/SilentDisco';
import FireSideChat from './e_summit_components/Registration/FireSideChat';
import CaseStudyCompetition from './e_summit_components/Registration/CaseStudyCompetition';
import PaperTrading from './e_summit_components/Registration/PaperTrading';
import Summit_copy from './Summit - Copy';
import Layout from './blog_components/Layout';
import IndexPage from './blog_components/IndexPage';
import LoginPage from './blog_components/LoginPage';
import { UserContextProvider } from './blog_components/UserContext';
import CreatePost from './blog_components/CreatePost';
import PostPage from './blog_components/PostPage';
import EditPost from './blog_components/EditPost';
import Esummit from './esummit'
import ProtectedRoute from './blog_components/ProtectedRoute';
import './blog_components/blog.css'
import EventBrochure from './esummit25/EventBrochure'
import { Navigate } from 'react-router-dom';
import Blog from './newecell/Blogs/Blog';
import BlogDetailPage from './newecell/Blogs/BlogDetailPage';
import PitchPulseRoutes from './pitchpulse';
function App() {
  return (
    <div>
      {/* <Main /> */}
      <BrowserRouter>
        <UserContextProvider>
          <ScrollToTop />
          <Routes>

            <Route path="/" element={<Main />} />
            <Route path="/recruitment" element={<RecruitmentPage />} />
            {/* Esummit */}
            <Route path="/event/:id" element={<EventBrochure />} />

            <Route path="/e_summit_2024" element={<Summit />} />
            {/* <Route path="/esummit2025" element={<ComingSoon />} /> */}
            <Route path="/esummit2025/startupexpo" element={<Startup />} />
            <Route path="/event/1" element={<Navigate to="/esummit2025/startupexpo" replace />} />
            <Route path="/esummit25/startupexpo" element={<Navigate to="/esummit2025/startupexpo" replace />} />
            <Route path="/esummit25" element={<Navigate to="/esummit2025" replace />} />
            <Route path="/esummit2025" element={<Esummit />} />
            <Route path="/new" element={<Newecell />} />
            <Route path="/parichay" element={<Summit_copy />} />
            <Route path="/e_summit_2024/registration" element={<FormLinks />} />
            <Route path="/e_summit_2024/registration/IshaanSharma" element={<IshaanSharma />} />
            <Route path="/e_summit_2024/registration/ProductDesign" element={<ProductDesign />} />
            <Route path="/e_summit_2024/registration/InternshipFair" element={<InternshipFair />} />
            <Route path="/e_summit_2024/registration/IPLAuction" element={<IPLAuction />} />
            <Route path="/e_summit_2024/registration/SilentDisco" element={<SilentDisco />} />
            <Route path="/e_summit_2024/registration/FireSideChat" element={<FireSideChat />} />
            <Route path="/e_summit_2024/registration/CaseStudyCompetition" element={<CaseStudyCompetition />} />
            <Route path="/e_summit_2024/registration/PaperTrading" element={<PaperTrading />} />
            {/* New Blogs */}
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:id" element={<BlogDetailPage />} />
            {/* Blogs */}
            <Route path="/blogs" element={<Layout />}>
              <Route index element={<IndexPage />} />
              <Route path="login-admin" element={<LoginPage />} />
              <Route path="create" element={<ProtectedRoute><CreatePost /></ProtectedRoute>} />
              <Route path="post/:id" element={<PostPage />} />
              <Route path="edit/:id" element={<EditPost />} />
            </Route>
            <Route path="/pitchpulse/*" element={<PitchPulseRoutes />} />
          </Routes>
        </UserContextProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
